export default {
  REFERRAL_CAMPAIGNS_FETCHED: 'REFERRAL_CAMPAIGNS_FETCHED',
  REFERRAL_CAMPAIGN_LOAD: 'REFERRAL_CAMPAIGN_LOAD',
  REFERRAL_CAMPAIGN_DETAIL: 'REFERRAL_CAMPAIGN_DETAIL',
  REFERRAL_CAMPAIGN_BUTTON_LOAD: 'REFERRAL_CAMPAIGN_BUTTON_LOAD',
};
